import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import TagFilter from '../../../../../core/components/inputs/TagFilter';

const TreeListFilters = ({
  classesCustom,
  searchFundNameQuery,
  setSearchFundNameQuery,
  fundTags,
  selectedFundTags,
  onFundTagsChange,
  fundFamilies,
  selectedFundFamily,
  handleFundFamilyChange,
  isFundFamilyFilterAvailable,
  isFundTagsFilterAvailable,
  listSide
}) => {
  let colSize = 12;
  if (isFundFamilyFilterAvailable && isFundTagsFilterAvailable) {
    colSize = 4;
  } else if (isFundFamilyFilterAvailable || isFundTagsFilterAvailable) {
    colSize = 6;
  }

  return (
    <Grid container justifyContent="center" spacing={2}>
      <Grid item xs={colSize}>
        <TextField
          margin="dense"
          value={searchFundNameQuery}
          onChange={e => setSearchFundNameQuery(e.target.value)}
          id={`search-input-${listSide}`}
          placeholder="Search Funds..."
        />
      </Grid>
      {isFundFamilyFilterAvailable && (
        <Grid item xs={colSize}>
          <Autocomplete
            options={fundFamilies}
            variant="standard"
            getOptionLabel={option => option.name}
            value={selectedFundFamily}
            onChange={handleFundFamilyChange}
            renderInput={params => (
              <TextField
                {...params}
                margin="dense"
                placeholder="All Fund Families"
              />
            )}
            classes={{
              popper: classesCustom.popperAutoComplete,
              paper: classesCustom.suggestionsPaperAutoComplete,
              listbox: classesCustom.listboxAutoComplete,
              option: classesCustom.optionAutoComplete
            }}
          />
        </Grid>
      )}
      {isFundTagsFilterAvailable && (
        <Grid item xs={colSize}>
          <TagFilter
            source="fundtags"
            tagsList={fundTags}
            selectedTags={selectedFundTags}
            onChange={onFundTagsChange}
            onChangeFundInv={() => null}
            displayTagFilter={true}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default TreeListFilters;
